import React from 'react';

const VERTICALS = [
  {
    icon: '🏥',
    name: 'Healthcare & Clinics',
    tagline: 'HIPAA Workflows & WebRTC Video',
    description: 'On-demand WebRTC video interpretation (GNL Interpreters), patient intake automation, HIPAA compliance workflows, and appointment follow-up bots.',
    deliverables: ['Medical Video Conferencing', 'HIPAA Log Auditing', 'Automated Appointment SMS'],
  },
  {
    icon: '🍽️',
    name: 'Restaurants & Hospitality',
    tagline: 'Cost Tracking & Guest CRM',
    description: 'Eliminate food waste with real-time supplier cost tracking, guest visit profiling, automated AI re-engagement, and POS data analytics.',
    deliverables: ['Supplier Waste Analytics', 'Customer Re-engagement Bot', 'Live Profitability Dashboards'],
  },
  {
    icon: '🏠',
    name: 'Real Estate & Property',
    tagline: 'Lead Nurture & Contract Automation',
    description: 'Automate client onboarding, lead tracking pipelines, property update notifications, and contract status tracking.',
    deliverables: ['Automated Lead Routing', 'Contract Status Tracker', 'Client Mobile Portals'],
  },
  {
    icon: '💼',
    name: 'Professional Services & FinTech',
    tagline: 'Invoicing & Client Portals',
    description: 'Automate invoice data extraction, electronic tax sync (DIAN compliance), client onboarding, and secure document sharing.',
    deliverables: ['PDF Data Extraction', 'Tax Compliance Sync', 'Secure Client Dashboards'],
  },
  {
    icon: '🚚',
    name: 'Logistics & Distribution',
    tagline: 'Shipment Tracking & Alerts',
    description: 'Real-time fleet and shipment tracking dashboards, automated supplier delivery alerts, and route efficiency reporting.',
    deliverables: ['Live Shipment Map', 'Supplier SMS Alerts', 'Route Cost Calculators'],
  },
  {
    icon: '🛍️',
    name: 'Retail & E-commerce',
    tagline: 'Inventory Alerts & Loyalty',
    description: 'Real-time inventory low-stock alerts, omnichannel customer loyalty tracking, and automated order fulfillment notifications.',
    deliverables: ['Inventory Threshold Alerts', 'Loyalty Engine', 'Fulfillment Sync'],
  },
];

const IndustryVerticals: React.FC = () => {
  return (
    <section id="industries" className="py-24 bg-gray-50 text-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <p className="text-blue-700 text-sm font-semibold uppercase tracking-widest mb-3">
            Industry Solutions
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 mb-4">
            We Automate Processes Across <span className="text-blue-700">Target Industries</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            If your business relies on manual data entry, repetitive phone/text coordination, or disconnected spreadsheets — we build the exact software to eliminate it.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VERTICALS.map((v) => (
            <div
              key={v.name}
              className="bg-white border border-gray-200 rounded-2xl p-7 hover:border-blue-300 hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-3xl p-2.5 bg-blue-50 rounded-xl">{v.icon}</span>
                  <div>
                    <h3 className="font-bold text-gray-900 text-lg leading-snug">{v.name}</h3>
                    <p className="text-xs font-semibold text-blue-700">{v.tagline}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{v.description}</p>
              </div>

              <div className="border-t border-gray-100 pt-4">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">Key Deliverables</p>
                <div className="space-y-1.5">
                  {v.deliverables.map((d, i) => (
                    <div key={i} className="flex items-center gap-2 text-xs font-medium text-gray-700">
                      <span className="text-blue-600 font-bold">✓</span>
                      <span>{d}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryVerticals;
